import { type ExclusionAreaFeature } from './exclusionAreaTypeResolution'

export const withOtherName = (
  exclusionAreas: ExclusionAreaFeature[] | null | undefined,
  featureId: string,
  newOtherName: string,
): ExclusionAreaFeature[] =>
  (exclusionAreas || []).map(exclusionArea =>
    exclusionArea.properties.id === featureId
      ? {
          ...exclusionArea,
          properties: { ...exclusionArea.properties, otherName: newOtherName },
        }
      : exclusionArea,
  )
